import React, {useState, useEffect} from 'react'
import Loading from '../../Commons/Loading/Loading';
import FooterFormulario from '../../Commons/FooterFormulario/FooterFormulario'
import { Link } from 'react-router-dom';

import DivisionBanner from '../../DivisionContainer/DivisionBanner/DivisionBanner';
import { Modal } from 'react-bootstrap'

import '../../../Styles/main.scss'
import '../DivisionesDetalles.scss'

const FibraOptica = () => {

    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);

    const [imgUrl, setImgUrl] = useState('');
    const [txtDes, setDesc] = useState('');

    const handleClose = () => {
        setShow(false);
    };
    
    const handleShow = (paramUrl, paramDesc) => {
        
        setImgUrl(paramUrl)
        setDesc(paramDesc)
        setShow(true)
        
        console.log(paramUrl, ', ', paramDesc);
    };

    useEffect(()=> {
        setTimeout(()=>{
            setLoading(false)
        }, 1000)
    })

    if(loading) {return <Loading />}

    return (

        <section className='container-fluid p-0 containerBlock' > 


            <Modal
              show={show}
              size='lg'
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Fibra Óptica</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <img src={imgUrl} alt="Modal de la imagen amplicada." className='d-block modal__size text-center' loading='lazy' />
              </Modal.Body>

              <Modal.Footer>
                <small >{txtDes}</small>
              </Modal.Footer>
            </Modal>

            <div className='divisionItem__container animated fast fadeIn'>
                <img src="../images/headers/headers-networking.jpg" 
                    alt="Fibra Optica para DTS y DAS." 
                    loading='lazy'
                    className='divisionItem__container--img'    
                />

                <div className='divisionItem__container--textos divisionItem__container--textos-2-lineas' >
                    <h3 className='divisionItem__container--header'>DIVISION</h3>
                    <h1 className='divisionItem__container--title'>TELECOMUNICACIONES</h1>
                </div>

            </div>

            <div className='container-fluid divisionItem__detail'>

                <div className='container animated fast fadeIn'>
                    <Link to={'/telecomunicaciones/'}>
                        <small> 
                            <i className="fas fa-angle-double-left" style={{'paddingBottom':'15px', 'paddingRight': '10px'}} ></i> 
                        Volver a Division
                        </small>
                    </Link>

                    <div className='row'>
                        
                        <div className='col-md-6'> 
                            <img 
                                src="../images/divisiones/telecomunicaciones/fibra-optica/enlaces-de-largos-vanos-y-dwdm/imagen-2.jpg" 
                                alt="Fibra Optica"
                                className='d-block w-100 divisionItem__detail--header'
                                loading='lazy'
                            /> 
                        </div>

                        <div className='col-md-6 pt-2'>
                            <h1 className='divisionItem__detail--title' >Fibra Optica</h1>
                            <p  className='divisionItem__detail--text' > 
                                Los cables de fibra óptica se transformaron en el medio más eficiente y 
                                versátil para establecer sistemas de telecomunicaciones de alta velocidad. 
                                A diferencia de un cableado trenzado, este puede transportar datos a grandes 
                                distancias, se obtienen menores pérdidas y mayor velocidad de transmisión. 
                                Entre ellas, nuestro destacado como sensores de temperatura y acústica.<br /><br />
                            </p> 
                        </div>

                    </div>

                    <div className='gallery__cont mt-5'>

                        <div className='gallery__cont--column33'>
                            <img    onClick={ () => handleShow('../images/divisiones/telecomunicaciones/fibra-optica/dts-y-das/imagen-1.jpg', 'Fibra Optica para DTS y DAS') } src='../images/divisiones/telecomunicaciones/fibra-optica/dts-y-das/imagen-1.jpg' alt='Fibra Optica para DTS y DAS.' loading='lazy'/>
                        </div>
                        <div className='gallery__cont--column33'>
                            <img    onClick={ () => handleShow('../images/divisiones/telecomunicaciones/fibra-optica/dts-y-das/imagen-3.jpg', 'Fibra Optica para DTS y DAS') } src='../images/divisiones/telecomunicaciones/fibra-optica/dts-y-das/imagen-3.jpg' alt='Fibra Optica para DTS y DAS.' loading='lazy' />
                        </div>
                        <div className='gallery__cont--column33'>
                            <img    onClick={ () => handleShow('../images/divisiones/telecomunicaciones/fibra-optica/dts-y-das/imagen-2.jpg', 'Fibra Optica para DTS y DAS') } src='../images/divisiones/telecomunicaciones/fibra-optica/dts-y-das/imagen-2.jpg' alt='Fibra Optica para DTS y DAS.' loading='lazy' />
                        </div>
                       
                    </div>

                </div>
            </div>

            <div>
                <h3 className='divisionItem__bajada--tit text-center'>
                    Otras Tareas
                </h3>
                <div className='row divisionItem__proyectosDestacados p-0'> 
                    <DivisionBanner 
                        division = {'Dts y Das'}
                        imgUrl = {'../images/divisiones/telecomunicaciones/dts-y-das.jpg'}
                        linkUrl = {'/telecomunicaciones/dts-das/'}
                    /> 
                   <DivisionBanner 
                        division = {'FTTx'}
                        imgUrl = {'../images/divisiones/telecomunicaciones/fttx.jpg'}
                        linkUrl = {'/telecomunicaciones/fttx/'}
                    /> 
                    <DivisionBanner 
                        division = {'Networking'}
                        imgUrl = {'../images/divisiones/telecomunicaciones/networking.jpg'}
                        linkUrl = {'/telecomunicaciones/networking/'}
                    /> 
                    <DivisionBanner 
                        division = {'Video Vigilancia'}
                        imgUrl = {'../images/divisiones/telecomunicaciones/videovigilancia-domotica.jpg'}
                        linkUrl = {'/telecomunicaciones/video-vigilancia/'}
                    /> 
                </div>
            </div>
            <FooterFormulario className='mt-5' />

        </section>
    )
}

export default FibraOptica